<template>
	<div class="production-info" :style="cardVars">
		<router-link :to="item.index">
			<div class="img_box">
				<img class="device_img" :src="item.path" :alt="item.desc">
				<img class="products" :src="item.devi" :alt="item.desc">
			</div>
		</router-link>
		<div class="color_filter">
			<img class="color_img" :src="item.back" />
			<p class="p_name" :class="{ 'yellow-text': yellow }">{{ item.desc }}</p>
		</div>
		<div class="device_name">
			<p>{{ item.name }}</p>
		</div>
		<div class="device_cont">
			<p>{{ item.cont }}</p>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ProductCard',
		props: {
			item: {
				type: Object,
				required: true
			},
			// 名称文字是否用黄色（原 index % 2 === 1）
			yellow: {
				type: Boolean,
				default: false
			},
			// 简介文字字号（首页 18px，产品中心 20px）
			contFontSize: {
				type: String,
				default: '18px'
			},
			// ≤800px 断点下设备背景图尺寸（首页 330×240，产品中心 360×260）
			img800Width: {
				type: String,
				default: '330px'
			},
			img800Height: {
				type: String,
				default: '240px'
			}
		},
		computed: {
			cardVars() {
				return {
					'--card-cont-fs': this.contFontSize,
					'--card-img800-w': this.img800Width,
					'--card-img800-h': this.img800Height
				}
			}
		}
	}
</script>

<style scoped>
	.production-info {
		margin-bottom: 40px;
	}

	.img_box {
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
	}

	.device_img {
		height: 290px;
		width: 400px;
	}

	.products {
		z-index: 10;
		position: absolute;
		transform: scale(1);
		transition: transform 1s;
		height: 220px;
		width: auto;
		margin-bottom: 30px;
	}

	/* 仅桌面（>1150px）且具备真实悬浮能力的设备（鼠标）上启用放大：
	   平板及以下不放大，同时避免触摸屏点击后 hover 状态卡住 */
	@media (hover: hover) and (min-width: 1151px) {
		.products:hover {
			transform: scale(1.2);
		}
	}

	.color_filter {
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		font-size: 20px;
	}

	.color_img {
		height: 55px;
		width: 320px;
	}

	.p_name {
		position: absolute;
	}

	.yellow-text {
		color: #ffef02;
	}

	.device_name {
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 25px;
		font-weight: 500;
	}

	.device_cont {
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: var(--card-cont-fs, 18px);
		white-space: pre-wrap;
	}

	@media screen and (max-width: 800px) {
		.device_img {
			width: var(--card-img800-w, 330px);
			height: var(--card-img800-h, 240px);
		}

		.products {
			width: auto;
			height: 170px;
		}

		.color_img {
			height: 44px;
			width: 260px;
		}

		.p_name {
			font-size: 1rem;
		}

		.device_name p {
			font-size: 18px;
			font-weight: bold;
		}

		.device_cont p {
			font-size: 16px;
		}
	}
</style>
